var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalTreatmentPackagingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8892 21.5116C43.8271 -6.0311 4.28809 -7.49082 0.32666 20.2194C1.1792 49.5382 44.0078 49.7694 41.8892 21.5116Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7194 12.008C12.9041 12.2302 11.9671 12.9171 11.0362 12.9078C10.1674 12.1451 10.4267 11.2348 11.1146 11.1554C12.9334 10.6491 15.0207 8.92116 15.3124 10.3001C17.8686 16.6383 20.3455 22.78 22.9003 29.1148C24.0701 30.1936 31.2723 25.3314 31.5149 26.7309C31.7382 27.3363 32.2385 27.9924 31.0131 28.2913C29.0729 29.0684 27.2869 29.7835 25.3193 30.5714C21.3411 32.3569 22.3887 31.7499 20.9883 28.7147C18.6219 23.5671 14.6198 11.3 13.7194 12.008Z",
    fill: "#193666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5398 27.329C22.9227 25.0633 20.0617 20.6513 21.6129 20.51C23.5476 19.865 25.3121 18.7496 27.3417 18.3555C27.9409 18.8069 27.9438 19.7456 28.3504 20.472C30.0438 25.1564 31.13 24.9715 28.2617 25.9637C26.4296 26.5043 24.0455 28.1676 23.5398 27.329Z",
    fill: "#193666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0881 12.3302C20.3369 11.637 23.9399 9.4481 24.3372 10.3523C25.0381 12.4259 26.3324 14.614 26.7914 16.8076C26.3575 17.3959 25.4435 17.3952 24.7421 17.7889C20.5824 19.2712 20.6477 20.3986 19.6671 17.5413C19.0613 15.5501 17.2249 12.811 18.0881 12.3302Z",
    fill: "#193666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5576 32.4357C15.6599 29.0037 20.5525 29.0999 20.7998 32.3161C20.6954 35.9588 15.7046 35.8019 15.5576 32.4357Z",
    fill: "#193666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalTreatmentPackagingIcon);
export default __webpack_public_path__ + "static/media/final-treatment-packaging-icon.6a885a6edd6082b95557f7a5a07e6ba9.svg";
export { ForwardRef as ReactComponent };